export const applyCepLookup = (convenio, dados = {}) => {
  if (!convenio) {
    return convenio
  }

  convenio.logradouro = dados.logradouro || convenio.logradouro
  convenio.bairro = dados.bairro || convenio.bairro
  convenio.uf = dados.uf || convenio.uf
  convenio.complemento = dados.complemento || convenio.complemento

  if (dados.ibge) {
    convenio.codigo_municipio = dados.ibge
  }

  return convenio
}

export const applyCnpjLookup = (convenio, dados = {}) => {
  if (!convenio) {
    return convenio
  }

  convenio.name = dados.razao || dados.fantasia || dados.name || convenio.name
  convenio.cnpj = dados.cnpj || convenio.cnpj
  convenio.email = dados.email || dados.mail || convenio.email
  convenio.cep = dados.cep || convenio.cep
  convenio.logradouro = dados.endereco || dados.logradouro || convenio.logradouro
  convenio.numero = dados.numero || convenio.numero
  convenio.complemento = dados.complemento || convenio.complemento
  convenio.bairro = dados.bairro || convenio.bairro
  convenio.uf = dados.uf || convenio.uf

  if (dados.codigo_municipio) {
    convenio.codigo_municipio = dados.codigo_municipio
  }

  if (dados.ibge) {
    convenio.codigo_municipio = dados.ibge
  }

  const codigoMunicipioFromCidade = dados.cidade && dados.cidade.codigo_ibge
    ? dados.cidade.codigo_ibge
    : null

  if (codigoMunicipioFromCidade) {
    convenio.codigo_municipio = codigoMunicipioFromCidade
  }

  return convenio
}
